/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useAppStore } from '@/store/modules/app';
import PayRule from './payRule/index.vue';
import PayMethod from './payMethod/index.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const gameInfo = computed(() => useAppStore().gameInfo);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(PayRule, {
        gid: _unref(gameInfo).Id
      }, null, 8, ["gid"]), _createVNode(PayMethod, {
        gid: _unref(gameInfo).Id,
        class: "marginT20"
      }, null, 8, ["gid"])]);
    };
  }
});